import { makeStyles } from "components/providers/makeStyles";
import { SearchTakeoverDialog } from "../forms/SearchTakeoverDialog";
import { SearchEventAndOrganisationDialog } from "./SearchEventAndOrganisation";
import { trackClick, trackingCategory } from "utils/tracking";

const useNewInputStyles = makeStyles(theme => ({
    input: {
        "&&": {
            marginBottom: 0,
            border: 0,
            padding: theme.spacing(2.5, 2),
            [theme.breakpoints.down("sm")]: {
                padding: theme.spacing(2, 1)
            },
            opacity: 0.7,
        }
    }
}));

export const NewSearchEventAndOrganisationInput = () => {
    const classes = useNewInputStyles();

    return (
        <SearchTakeoverDialog
            DialogComponent={SearchEventAndOrganisationDialog}
            inputPlaceholder="Search events and organisations"
            dialogTitleId="event-organisation-search-dialog"
            className={classes.input}
            showSearchIcon={true}
            onClick={trackClick("Search input button", trackingCategory.searchEventAndOrganisation)}
        />
    );
};
